import { useConnect } from '@lore/query-connect';
import { offer_networkId } from '@/utils/query-helpers';

export default function useQuery(props) {
  const {
    network,
    pagination = {},
    params = {}
  } = props;

  return useConnect('claim.find', {
    where: {
      eager: {
        $where: {
          ...offer_networkId(network),
          request: { $not: 'Outreach' },
          ...params
        }
      }
    },
    ...pagination
  }, {
    keepPreviousData: true
  });
}
